module.exports = __webpack_public_path__ + "img/f_ic_supplier.383ec71a.svg";